// @ts-check
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classes from './DropdownMenu.module.scss';
import cx from 'classnames';

class DropdownMenu extends Component {
  constructor(props, state) {
    super(props, state);
    this.state = { isOpen: this.props.open || false };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleWindowClick = this.handleWindowClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleWindowClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
  }

  toggleOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handleWindowClick(event) {
    // TODO: Should we do `event.preventDefault();` here? To stop event from propogating.
    //       Reason to maybe do this is if the click outside the dropdown menu is just to
    //       hide the dropdown menu, rather than to actually `click` something. It is
    //       potentially a little surprising as the user if you click to hide dropdown,
    //       but happen to click a button or something and it does something.
    const element = findDOMNode(this);
    if (event.target !== element && !element.contains(event.target) && this.state.isOpen) {
      this.toggleOpen();
    }
  }

  render() {
    const { isOpen } = this.state;
    const { children } = this.props;

    return (
      <div
        className={cx(classes.dropdownMenu, {
          [classes.contentOpen]: isOpen,
          [classes.contentClosed]: !isOpen,
        })}
        onClick={this.toggleOpen}
      >
        {children}
      </div>
    );
  }
}

export default DropdownMenu;
